export const TO_DO_DISPLAY_BELL_COLUMN = 7;
export const TO_DO_NOT_DISPLAY_BELL_COLUMN = 12;
export const SEE_MORE_DISPLAY_BELL_COLUMN = 15;
export const SEE_MORE_NOT_DISPLAY_BELL_COLUMN = 12;
